import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PreloadAllModules } from '@angular/router';
// Consts
import { pcPath, mobilePath } from './app-path.const';
// Componetns
import { AppComponent } from './app.component';
import { NopageComponent } from './pages/error-pages/nopage/nopage.component';

const routes: Routes = [
  {
    path: 'pc',
    loadChildren: () => import('./pages/pc/pc.module').then(mod => mod.PcModule)
  },
  {
    path: 'mb',
    loadChildren: () => import('./pages/mb/mb.module').then(mod => mod.MbModule)
  },
  {
    path: 'error/no-this-page',
    component: NopageComponent,
  },
  {
    path: '**',
    component: AppComponent,
    children: []
    // redirectTo: 'error/no-this-page',
    // pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: true,
    preloadingStrategy: PreloadAllModules
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
